// unlockPrivateStream.js
'use strict';
import setLivestreamPaymentTimer from '../action/setLivestreamPaymentTimer.js';
import openRecommendDiamondPackSelector from '../action/openRecommendDiamondPackSelector.js';
import setPrivateStreamAutoPayment from '../action/setPrivateStreamAutoPayment.js';

import getLiveStreamData from '../selector/getLiveStreamData.js';

import {
  PRECHARGE_SECONDS,
  livestreamPaymentVia as livestreamPaymentViaConstant,
  PRESET_SD,
} from '../resource/liveStreamConstants.js';

/**
 * Unlock private stream
 * @kind action
 * @param {string} {streamId} - stream id.
 * @return {Promise} Action promise.
 */
const unlockPrivateStream =
  ({ streamId }) =>
  async (dispatch, getState) => {
    if (!streamId) return dispatch({ type: '' });

    const productId = getLiveStreamData(
      getState(),
      [streamId, 'shop'],
      'productId'
    );
    if (productId) {
      return openRecommendDiamondPackSelector({
        productIds: [productId],
        via: 'unlock-livestream',
        recommendProductId: productId,
      });
    }
    const privateLiveStreamStartTimestamp = getLiveStreamData(
      getState(),
      [streamId, 'presets', PRESET_SD],
      'nbf'
    );
    const privateStreamCounterExp = getLiveStreamData(
      getState(),
      [streamId, 'presets', PRESET_SD, 'counter'],
      'exp'
    );
    const paymentTimestamp =
      privateLiveStreamStartTimestamp || privateStreamCounterExp;

    dispatch(setPrivateStreamAutoPayment({ streamId, isEnabled: true }));
    return dispatch(
      setLivestreamPaymentTimer({
        streamId,
        paymentTimestamp: paymentTimestamp - PRECHARGE_SECONDS,
        via: livestreamPaymentViaConstant.CLICK,
      })
    );
  };

export default unlockPrivateStream;
